import Radio from './Radio'

export default {
  name: 'KRadioButton',
  mixins: [Radio],
  inject: ['radioGroup'],
  props: {},
  data() {
    return {
      isButton: true,
    }
  },
  computed: {
    checkedTheme() {
      return this.radioGroup.checkedTheme
    },
    checkedType() {
      return this.radioGroup.checkedType
    },
    uncheckedTheme() {
      return this.radioGroup.uncheckedTheme
    },
    uncheckedType() {
      return this.radioGroup.uncheckedType
    },
    attrName() {
      return this.radioGroup.name
    },
    groupValue() {
      return this.radioGroup.innerValue
    },
    size() {
      return this.radioGroup.size
    },
    capsule() {
      return this.radioGroup.capsule
    },
    capsuleType() {
      return this.radioGroup.capsuleType
    },
    cancelable() {
      return this.radioGroup.cancelable
    },
  },
  watch: {
    groupValue: {
      immediate: true,
      handler(value) {
        this.innerChecked = value === this.value
      },
    },
    innerChecked(value) {
      if (value) {
        this.radioGroup.handleValueChange(this.value)
      } else {
        this.$refs.input.checked = false
      }
    },
  },
  methods: {
    // handleValueChange(value) {
    //   this.radioGroup.handleValueChange(value)
    // },
  },
}
